export default __webpack_public_path__ + "static/media/gallery_09.fd10d99f.jpg";